<template>
 <Layout>
    <PageHeader :title="title" :items="items" />
     <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-xl-6" v-for="(user,i) in users" :key="i">
              <div class="card" style="cursor:pointer" @click="redirect(user.queryParams)">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div>
                      <h5 class="card-title me-2">{{ user.title }}</h5>
                      <h4>{{ user.count }}</h4>
                    </div>
                    <div class="ms-auto align-self-end">
                        <i :class="`bx bx-group display-4 text-${user.color}`"></i>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
         </div>
        </div>  
       <div class="col-md-6">
        <div class="card">
          <div class="card-body">
          <h4 class="card-title mb-4">Yeni Kurulumlar ve Sökümler (6 Aylık)</h4>
          <apexchart
            class="apex-charts"
            dir="ltr"
            height="300"
            :series="series"
            :options="chartOptions"
          ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card border-top border-success">
           <div class="card-header bg-transparent">
             <div class="d-flex justify-content-between">
              <div class="me-2">
                <h5 class="card-title">Gerçekleşen Ödemeler</h5>
              </div>
              <div class="ms-auto">
                  <div class="button-items">
                    <button @click="todaysPayment()" class="btn btn-white text-muted btn-md p-0" type="button">
                      <div class="btn-content"><i class="fas fa-sync"></i></div>
                    </button>
                  </div>
                </div>
            </div>
          </div>
          <div>
            <Loader :loading="true" :load="userLoading">
              <div class="table-responsive mb-0">
                <simplebar style="max-height: 330px">
                  <table class="table align-middle table-n<zowrap">
                    <thead class="table-light sticky-top">
                      <tr>
                        <th class="align-middle">MÜŞTERİ KULL. ADI</th>
                        <th class="align-middle">ÖDENEN</th>
                        <th class="align-middle">ÖDEME TÜRÜ</th>
                        <th class="align-middle">ÖDEME ALAN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in payUsers.list" :key="data.id">
                        <td>{{ data.username }}</td>
                        <td><amount>{{ data.amount }}</amount></td>
                        <td>{{ data.payment_type_name }}</td>
                        <td>{{ data.user_name }}</td>
                      </tr>
                    </tbody>
                  </table>
              </simplebar>
            </div>
            </Loader>
          </div>
          <div class="card-footer bg-transparent">
              <div class="d-flex justify-content-between px-0 py-0">
              Toplam : {{ payUsers.cnt }} Tahsilat {{ payUsers.total }} TL
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <div class="col-md-6">
        <div class="card border-top border-danger">
           <div class="card-header bg-transparent">
             <div class="d-flex justify-content-between px-0 py-0">
                <h5 class="card-title">Süresi Bitmeye Yakınlar</h5>
                <div class="ms-auto">
                  <div class="button-items">
                    <button @click="getUsers()" class="btn btn-white text-muted btn-md p-0" type="button">
                      <div class="btn-content"><i class="fas fa-sync"></i></div>
                    </button>
                  </div>
                </div>
            </div>
          </div>
          <div>
            <Loader :loading="true" :load="sureLoading">
              <div class="table-responsive mb-0">
                <simplebar style="max-height: 230px">
                  <table class="table align-middle table-nowrap">
                    <thead class="table-light sticky-top">
                      <tr>
                        <th class="align-middle">KULLANICI ADI</th>
                        <th class="align-middle">İSİM SOYİSİM</th>
                        <th class="align-middle">TARİFE A.</th>
                        <th class="align-middle">BİTİŞ TARİHİ</th>
                        <th class="align-middle">KALAN GÜN</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in lastUsers" :key="data.id">
                        <td>{{ data.username }}</td>
                        <td>{{ data.fullname }}</td>
                        <td>{{ data.tariff_name }}</td>
                        <td>{{ data.formatted_expiredate }}</td>
                        <td>{{ data.gun_farki == 0 ? 'Bugün' : data.gun_farki }}</td>
                      </tr>
                    </tbody>
                  </table>
              </simplebar>
            </div>
            </Loader>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
</Layout> 
</template>
<style>
.bgc-primary{background-image: linear-gradient(to left, rgba(1, 98, 232, 0.5) 0%, #0162e8 100%) !important;}
.bgc-danger{background-image: linear-gradient(45deg, #f93a5a, #f7778c) !important;}
.bgc-success{background-image: linear-gradient(to left, #48d6a8 0%, #029666 100%) !important;}
.bgc-warning{background-image: linear-gradient(to left, #efa65f, #f76a2d) !important;}
.bgc-info{background-image: linear-gradient(to right, #4800c9 0%, #884af1 100%) !important;}
amount{
  font-size:14px;
  font-weight: bold;
  color:#029666
}
</style>
<script>
import Layout from "../../layouts/main";
import Loader from "../../.././components/widgets/loader.vue";
import simplebar from "simplebar-vue";
import PageHeader from "@/components/page-header";

export default {
   page: {
    title: "Tarife Yönetimi",
   },
   components: {
    Layout,
    PageHeader,
    simplebar,
    Loader,
  },
  data() {
      return {
        title: "Anasayfa",
        items: [
          {
            text: "ANASAYFA",
            href: "/",      
            active: true,
          }
        ],
        series:[],
        chartOptions: {
          chart: {
            height: 320,
            type: "line",
            toolbar: "false", 
            dropShadow: {
              enabled: true,
              color: "#000",
              top: 18,
              left: 7,
              blur: 8,
              opacity: 0.2,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors:['#34C38F','#F1B450', '#F46A6A'],
          stroke: {
            curve: "smooth",
            width: 3,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            labels: {
              formatter: function(val) {
                return Math.floor(val)
              }
            }
          }
        },
        hideData:false,
        userLoading:true,
        sureLoading:true,
        w1Loading:true,
        w2Loading:true,
        w3Loading:true,
        earnLoading:true,
        lastUsers : [],
        payUsers:[],
        users: [
          { title:"Online Abone",count: 0,color: "success", queryParams : "99" },
          { title:"Aktif Abone",count: 0,color: "success", queryParams : "1" },
          { title:"Günü Biten Abone",count: 0,color: "warning", queryParams : "2"  },
          { title:"İptal Abone",count: 0,color: "danger", queryParams : "3"  },
          { title:"Dondurulmuş Abone",count: 0,color: "info", queryParams : "4" },
          { title:"Günü Olup Bağlantısı Olmayan",count: 0,color: "secondary", queryParams : "98" },
        ],
        userAlarms:[
          { title:"Kurulum Bekleyenler", count:0 },
          { title:"Söküm Bekleyenler", count:0 },
          { title:"Taşıma Bekleyenler", count:0 },
          { title:"Arıza Çözüm Bekleyenler", count:0 }
        ],
        kurulumlar:{},
      }
  },
  created(){
    this.getUsers();
    this.distribution();
    this.todaysPayment();
    this.yeniKurulumlar();
  },
  methods:{
    redirect(query){
      location.href='/musteri-listesi?status=' + query
    },  
    asterisk(data){
      return this.hideData ? '****' : data; 
    }, 
    getUsers(){  
        this.sureLoading = true
        this.$http.get('/dashboard/lastUsers')
        .then(resp => {
          this.sureLoading = false
          this.lastUsers = resp.data;
        })
        .catch(error => error)
    },  
    todaysPayment(){  
        this.userLoading = true
        this.$http.get('/dashboard/todaysPayment')
        .then(resp => {
          this.payUsers = resp.data;
          this.userLoading = false
        })
    },  
    yeniKurulumlar(){  
        this.$http.get('/dashboard/newInstalled')
        .then((response)=> {

            const data0 = response.data[0].map(e=>e.cnt)
            const data1 = response.data[1].map(e=>e.cnt)
            const data2 = response.data[2].map(e=>e.cnt)
  
            this.series = [
              {
                name: "Kurulum Sayısı",
                data:data1,
                type: 'line',
              },
              {
                name: "Günü Biten",
                data:data0,
                type: 'column',
              },
              {
                name: "Söküm Sayısı",
                data:data2,
                type: 'line',
              }
            ] 

            const labels = response.data[1].map(e=>e.month + " " +e.year)
            this.chartOptions = { xaxis: { categories : labels }}
        })
    },
    distribution(){  
        this.w1Loading = true
        this.w2Loading = true
        this.w3Loading = true
        this.$http.get('/dashboard/status')
        .then(resp => {
          this.w1Loading = false
          this.w2Loading = false
          this.w3Loading = false
          this.usersList(resp.data)
         
        })
        .catch(error => error)
    },
    usersList(resp){
      resp.forEach(e => {
        if(e.status == 99){
            this.users[0].count = e.cnt
        }
        if(e.status == 1){
            this.users[1].count = e.cnt
        }
        if(e.status == 2){
            this.users[2].count = e.cnt
        }
        if(e.status == 3){
            this.users[3].count = e.cnt
        }
         if(e.status == 4){
            this.users[4].count = e.cnt
        }
        if(e.status == 5){
            this.users[5].count = e.cnt
        }
        if(e.status == 98){
            this.users[6].count = e.cnt
        }
      });
       
    }
  }
}
</script>